import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DigitalSignatureCommonService } from '@app/requests/logalty-digital-signature/digital-signature-service/digital-signature-common.service ';
import { TranslateService } from '@ngx-translate/core';
import { DigitalSignatureServiceStore } from '@app/requests/logalty-digital-signature/digital-signature-service/digital-signature-service.store';
import { Operation } from '@app/requests/model/requests-model';
import { CredentialsService } from '@app/login';
import {
  IntervenersDigitalSignatureDTO,
  IntervenientsDTO,
  IntervenientsSignatureDTO,
} from '@app/requests/model/logalty-signature-model';
import { DetectDeviceService } from '@app/@shared/services/utils/detect-device.service';
import { DigitalSignatureServiceApi } from '@app/requests/logalty-digital-signature/digital-signature-service/digital-signature-service-api.service';
@Component({
  selector: 'app-logalty-call-back',
  templateUrl: './logalty-call-back.component.html',
  styleUrls: ['./logalty-call-back.component.scss'],
})
export class LogaltyCallBackComponent implements OnInit {
  public numOperation: string;
  public responseOK: boolean = false;
  public guid: string;
  public feedback: string;
  public isAsync: boolean = false;
  public signature_end_back: boolean = false;
  @Output() keepSearch = new EventEmitter<any>();
  public hasToolbar: boolean = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public translate: TranslateService,
    private digitalSignatureServiceStore: DigitalSignatureServiceStore,
    private digitalSignatureCommonService: DigitalSignatureCommonService,
    private detectDeviceService: DetectDeviceService,
    private credentialsService: CredentialsService,
    public digitalSignatureService: DigitalSignatureServiceApi
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.isAsync = this.digitalSignatureServiceStore.isAsync;
      this.guid = params['nodeid'] ? params['nodeid'] : '';
      this.signature_end_back = params['signature_end'];

      if (this.guid?.length > 0) {
        this.digitalSignatureCommonService.setGUIDSignature(this.guid);
      } else {
        this.guid = this.digitalSignatureCommonService.getGUIDSignature();
      }

      this.feedback = params['feedback'];
      this.feedback = decodeURIComponent(this.feedback).replace(/(\r\n|\n|\r)/gm, '');
      let exp = /<signature_states>(.*?)<\/signature_states>/g;
      let signature_states = this.feedback.match(exp);
      let valueDate: Date;
      let stateValid: string;

      if (signature_states && signature_states.length > 0) {
        let exp2 = /<signature_state(.*?)<\/signature_state>/g;
        let signature_state = signature_states[0].match(exp2);
        signature_state.forEach((state) => {
          if (valueDate === undefined) {
            let date = state.split('+date="')[1].split('"+')[0];
            let dateText = date.toString();
            valueDate = new Date(dateText);
            stateValid = state.split('+value=')[1].split('"')[1];
          } else if (new Date(state.split('+date="')[1].split('"+')[0]) > valueDate) {
            let date = state.split('+date="')[1].split('"+')[0];
            let dateText = date.toString();
            valueDate = new Date(dateText);
            stateValid = state.split('+value=')[1].split('"')[1];
          }
        });
      } else {
        console.log('error respuesta firma');
      }

      this.numOperation = this.digitalSignatureCommonService.getNumOperationSignature();

      if (this.signature_end_back) {
        this.hasToolbar = true;
        let signatureEnd = JSON.parse(localStorage.getItem('signatureEnd'));
        stateValid = signatureEnd.stateValid;
        this.signature_end_back = false;
      }

      const code = localStorage.getItem('ThirdPartyCode');
      this.digitalSignatureServiceStore.SetSignFinish(code).then(
        () => {
          console.log('OK setSignFinish');
        },
        (error) => {
          console.error('Error setSignFinish', error);
        }
      );

      if (stateValid === '7') {
        this.responseOK = true;
        localStorage.setItem('signatureEnd', JSON.stringify({ saml: 'signature_end', stateValid: '7' }));
      } else {
        this.responseOK = false;
        localStorage.setItem('signatureEnd', JSON.stringify({ saml: 'signature_end', stateValid: null }));
      }

      this.digitalSignatureServiceStore.setSAMLdata(null);
    });
  }

  public goToPanel() {
    let operation: Operation = this.digitalSignatureCommonService.getOperation();
    let signatureDto: IntervenientsSignatureDTO = this.fillSignatureDTO(operation);
    localStorage.removeItem('signatureEnd');
    let interveners: IntervenientsDTO[];
    this.digitalSignatureService
      .getParticipantsSignature(signatureDto)
      .subscribe((data: IntervenersDigitalSignatureDTO) => {
        interveners = data.interveners;
        if (
          (interveners != null || interveners != undefined) &&
          interveners.length > 1 &&
          !interveners.every((e: IntervenientsDTO) => {
            return e.document_result === '7';
          })
        ) {
          this.digitalSignatureServiceStore.manageSignature(
            operation,
            false,
            this.detectDeviceService.isAccessByDevice(),
            false
          );
        } else {
          let pageOpenSignature = JSON.parse(localStorage.getItem('pageOpenSignature'));
          this.router.navigate([pageOpenSignature.url, { keepFilter: true }]);
        }
      });
  }

  private fillSignatureDTO(operation: Operation) {
    let signatureDto = {} as IntervenientsSignatureDTO;
    signatureDto.numOperation = operation.numOperation;
    signatureDto.language = 'es-' + operation.language;
    signatureDto.printContract = false;
    signatureDto.financialProduct = operation.finacialProduct;
    signatureDto.nameContract = operation.comarca;
    signatureDto.versionContract = operation.version;
    signatureDto.accessByDevice = 'N';
    return signatureDto;
  }
}
